var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFarmerKind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_155_55161)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    transform: "translate(2 2)",
    fill: "white",
    fillOpacity: 0.01,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5C7.62916 5 7.26665 5.10997 6.95831 5.31599C6.64997 5.52202 6.40964 5.81486 6.26773 6.15747C6.12581 6.50008 6.08868 6.87708 6.16103 7.24079C6.23338 7.60451 6.41195 7.9386 6.67418 8.20083C6.9364 8.46305 7.27049 8.64163 7.63421 8.71397C7.99792 8.78632 8.37492 8.74919 8.71753 8.60727C9.06015 8.46536 9.35298 8.22504 9.55901 7.91669C9.76504 7.60835 9.875 7.24584 9.875 6.875C9.875 6.37772 9.67746 5.90081 9.32583 5.54917C8.9742 5.19754 8.49728 5 8 5ZM8 8C7.7775 8 7.55999 7.93402 7.37499 7.8104C7.18998 7.68679 7.04579 7.51109 6.96064 7.30552C6.87549 7.09995 6.85321 6.87375 6.89662 6.65552C6.94003 6.43729 7.04717 6.23684 7.20451 6.0795C7.36184 5.92217 7.5623 5.81502 7.78053 5.77162C7.99875 5.72821 8.22495 5.75049 8.43052 5.83564C8.63609 5.92078 8.81179 6.06498 8.93541 6.24998C9.05902 6.43499 9.125 6.6525 9.125 6.875C9.12466 7.17326 9.00603 7.45922 8.79513 7.67012C8.58422 7.88103 8.29827 7.99966 8 8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.75C6.96165 2.75 5.94662 3.05791 5.08326 3.63478C4.2199 4.21166 3.54699 5.0316 3.14963 5.99091C2.75227 6.95022 2.64831 8.00582 2.85088 9.02422C3.05345 10.0426 3.55347 10.9781 4.28769 11.7123C5.02192 12.4465 5.95738 12.9466 6.97578 13.1491C7.99418 13.3517 9.04978 13.2477 10.0091 12.8504C10.9684 12.453 11.7883 11.7801 12.3652 10.9167C12.9421 10.0534 13.25 9.03835 13.25 8C13.2484 6.60809 12.6948 5.27365 11.7106 4.28942C10.7264 3.3052 9.39191 2.75157 8 2.75ZM5.75 11.8912V11.375C5.75033 11.0767 5.86896 10.7908 6.07987 10.5799C6.29078 10.369 6.57673 10.2503 6.875 10.25H9.125C9.42327 10.2503 9.70923 10.369 9.92014 10.5799C10.131 10.7908 10.2497 11.0767 10.25 11.375V11.8912C9.56719 12.2899 8.7907 12.5 8 12.5C7.20931 12.5 6.43281 12.2899 5.75 11.8912ZM10.9972 11.3472C10.9897 10.8553 10.7893 10.386 10.4391 10.0405C10.0889 9.69493 9.61697 9.50084 9.125 9.5H6.875C6.38304 9.50084 5.9111 9.69493 5.5609 10.0405C5.2107 10.386 5.01027 10.8553 5.00281 11.3472C4.32278 10.74 3.84321 9.9405 3.62763 9.05467C3.41204 8.16885 3.4706 7.23843 3.79555 6.38662C4.12051 5.53482 4.69652 4.8018 5.44733 4.28464C6.19814 3.76747 7.08832 3.49056 8 3.49056C8.91169 3.49056 9.80187 3.76747 10.5527 4.28464C11.3035 4.8018 11.8795 5.53482 12.2045 6.38662C12.5294 7.23843 12.588 8.16885 12.3724 9.05467C12.1568 9.9405 11.6772 10.74 10.9972 11.3472Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_155_55161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmerKind);
export default __webpack_public_path__ + "static/media/farmer-kind.6756ea123fb5ec8ec9690d42af87e44f.svg";
export { ForwardRef as ReactComponent };